import { render, staticRenderFns } from "./ViewDetails.vue?vue&type=template&id=2df7728e&scoped=true"
import script from "./ViewDetails.vue?vue&type=script&lang=ts"
export * from "./ViewDetails.vue?vue&type=script&lang=ts"
import style0 from "./ViewDetails.vue?vue&type=style&index=0&id=2df7728e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df7728e",
  null
  
)

export default component.exports